export const MAX_NPS_DAYS = 90
export const MIN_NPS_DAYS = 30
